<template>
  <div ref="videoWrapper" :class="{ 'modal-video__wrap': true, 'modal-video__wrap--hidden': !this.showVideo }">
    <video v-if="!isMobile" ref="video" loop muted playsinline preload="metadata">
      <source :src="this.srcAv" type="video/mp4; codecs=av01.0.05M.08" />
      <source :src="this.src" type="video/mp4" />
    </video>
  </div>
</template>

<script>
import { BREAKPOINTS } from '~scripts/core/breakpoints';

export default {
  name: 'ForumModalVideo',
  props: {
    src: String,
    srcAv: String,
    modalIdentificator: String,
  },
  data() {
    return {
      isMobile: false,
      modal: null,
      form: null,
      showVideo: true,
    };
  },
  computed: {
    breakpoints() {
      return BREAKPOINTS;
    },
    mediaSm() {
      return window.matchMedia(`(max-width: ${this.breakpoints.smMax})`);
    },
  },
  mounted() {
    this.modal = document.getElementById(this.modalIdentificator);
    this.form = this.modal.querySelector('form');
    this.mediaSm.addEventListener('change', this.handleMediaChange);
    this.handleMediaChange(this.mediaSm);

    this.modal.addEventListener('open-modal', this.handleOpenModal);
    this.modal.addEventListener('close-modal', this.handleCloseModal);
    document.addEventListener('form-send', this.handleFormSend);
    this.toggleShowVideo();
  },
  beforeDestroy() {
    this.mediaSm.removeEventListener('change', this.handleMediaChange);
    this.modal.removeEventListener('open-modal', this.handleOpenModal);
    this.modal.removeEventListener('close-modal', this.handleCloseModal);
    this.form.removeEventListener('form-send', this.handleFormSend);
  },
  methods: {
    handleMediaChange(event) {
      this.isMobile = event.matches;
    },
    playVideo() {
      this.$refs.video.play();
    },
    stopVideo() {
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },
    handleOpenModal() {
      if (!this.isMobile) {
        this.playVideo();
      }
    },
    handleCloseModal() {
      if (!this.isMobile) {
        this.stopVideo();
      }
    },
    handleFormSend() {
      this.showVideo = false;

      const videos = document.querySelectorAll('.js-video');
      const videoWraps = document.querySelectorAll('.modal-video__wrap');

      videos.forEach((video) => {
        const isVideoHidden = video.classList.contains('video--hidden');

        if (isVideoHidden) {
          video.classList.remove('video--hidden');
        }
      });
      videoWraps.forEach((element) => {
        element.classList.add('modal-video__wrap--hidden');
      });
    },
    toggleShowVideo() {
      this.$nextTick(() => {
        this.showVideo = !window.localStorage.getItem('forum2023FormSubmitted');
      });
    },
  },
};
</script>
